import { Stone } from '@/game/Board';

export default class InputValidator {
  constructor() {
    if(new.target === InputValidator)
      throw new TypeError('InputValidator is abstract');
  }

  get inputType() { return Stone.BLACK; }
  validate(point) { return Boolean(point); }
}
